import { permissionScopes } from './TeamConstants'

export const hasScope = scope => ({ scopes }) => scopes.includes(scope)

export const hasCalendarScope = hasScope(permissionScopes.CALENDAR_USER)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/team/InviteHelpers.js